export default defineNuxtPlugin(() => {
  const { $pwa } = useNuxtApp()
  const pwa = $pwa as any

  if (pwa && typeof pwa.on === 'function') {
    // Handle PWA installation prompt
    pwa.on('install-prompt', (e: any) => {
      console.log('PWA install prompt triggered')
      // You can show a custom install prompt here
    })

    // Handle PWA updates
    pwa.on('update-found', () => {
      console.log('PWA update found')
      // You can show a notification to the user about the update
    })

    // Handle PWA offline/online status
    pwa.on('offline-ready', () => {
      console.log('PWA is ready for offline use')
    })

    // Handle PWA registration
    pwa.on('registered', () => {
      console.log('PWA service worker registered')
    })

    // Handle PWA errors
    pwa.on('error', (error: any) => {
      console.error('PWA error:', error)
    })
  }
}) 